import { LazyModule, LazyAction } from 'owa-bundling';

const lazyModule = new LazyModule(() =>
    import(/* webpackChunkName: "MailFilterActions", webpackPrefetch: true */ './lazyIndex')
);

export let lazySelectFilter = new LazyAction(lazyModule, m => m.selectFilter);
export let lazySelectSort = new LazyAction(lazyModule, m => m.selectSort);
export let lazyTogglePauseInbox = new LazyAction(lazyModule, m => m.togglePauseInbox);

export { default as clearFilter } from './actions/clearFilter';
